module.exports = __webpack_public_path__ + "static/catering-1d190ebdf902134b533abe275f456544.jpg";